import React, { useEffect, useState } from "react";
import { SlArrowDown } from "react-icons/sl";
import Search from "../assets/icons/search.svg";
import { CgArrowLeft } from "react-icons/cg";
import Modal from "../components/modals/Modal";
import CoursesReqModal from "../components/modals/CoursesReqModal";
import { motion } from "framer-motion";
import { getProgrammesUnderInst } from "../api/services";
import { AiOutlineEye } from "react-icons/ai";
import DashboardLayout from "./DashboardLayout";
import { Link, useSearchParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import Pagination2 from "../components/Pagination2";

const BrochureCourses = () => {
  const [searchParams] = useSearchParams();
  const schoolId = searchParams.get("id");
  const schoolName = searchParams.get("school");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);

  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState([]);

  // const [alpha, setAlpha] = useState('All')
  const [filterLetter, setFilterLetter] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  // const alphabets = ['All', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

  const handleDetails = (item) => {
    setModal(true);
    setModalData(item);
    // console.log(item, 'DETAILS');
  };

  //   GET COURSES FOR INSTITUTION
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await getProgrammesUnderInst(
          schoolId,
          currentPage,
          setLoading,
          searchTerm
        );
        setCourses(data?.data);
        setTotalPages(data?.last_page);
        console.log(searchTerm, "COURSES PAGE");
      } catch (error) {
        // setError(error);
        console.log(error, "THis is the error");
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [schoolId, currentPage, searchTerm]);

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(searchValue);
    // setShowFilter(true)
    // setAlpha('All')
    // const searchResult = courses.filter((item) => item.title.toLowerCase().includes(searchValue));
    // setFilterLetter(searchResult);
  };

  // const handleAlpha = (alphabet) => {
  //   if(alphabet !== 'All'){
  //     // setAlpha(alphabet)
  //     setShowFilter(true)
  //     const filteredCourses = courses.filter((item) => item.title.toLowerCase().startsWith(alphabet.toLowerCase()));
  //     setFilterLetter(filteredCourses);
  //   }else if(alphabet === 'All'){
  //     // setAlpha(alphabet)
  //     setShowFilter(false)
  //     setSearchTerm('');
  //   }

  // }

  return (
    <DashboardLayout
      brochure="Brochure by institution"
      childTab={11}
      animated={true}
    >
      <div className="flex flex-col items-center justify-start w-full px-5 pb-7 mt-10 md:px-6 lg:relative lg:px-7 xl:px-10 xl:pb-10">
        <motion.div
          animate={{
            opacity: [0, 0.1, 0.2, 0.3, 0.5, 0.7, 1],
            scale: 1,
            x: ["100%", "0%"],
          }}
          transition={{ duration: 1, delay: 0.2 }}
          initial={{ opacity: 1, scale: 1 }}
          className="flex flex-col items-center justify-start w-full"
        >
          {/*TOP INPUTS* */}
          <div className="flex items-start justify-start w-full flex-wrap md:absolute md:z-10 md:px-6 lg:px-7 xl:px-10">
            {/*SEARCH*/}
            <div className="flex flex-col items-start mt-4 w-full bg-white md:mt-0">
              <p className="text-[11px] text-[#101828] font-medium w-full xl:text-sm">
                Search courses
              </p>
              <div className="relative flex justify-start h-9 mt-1 w-full xl:h-11">
                <input
                  className="border-[1px] rounded-md border-[#DDE1E6] h-full w-full bg-white text-[10px] text-[#101828] font-normal pl-9 outline-[#25A249] 
                                      xl:text-sm xl:pl-12 xl:rounded-lg"
                  placeholder="Search course name"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <img
                  className="absolute left-3 top-[10px] w-[14px] xl:w-4 xl:top-[14px] xl:left-5"
                  src={Search}
                  alt="search_icon"
                />
              </div>
            </div>
          </div>

          {/* ALPHABETS */}
          {/* <div className='flex items-center justify-start w-full flex-wrap mt-5 md:mt-20 lg:justify-between lg:mt-[85px] xl:mt-28'>
             {alphabets.map((item) => {
              return(
                <div onClick={()=>handleAlpha(item)} className={`flex items-center justify-center px-[8px] py-1 mr-[6px] my-[2px] cursor-pointer rounded-3xl md:mr-[10px] lg:mx-0
                                                                ${alpha === item && 'border-[1px] border-[#25A249]'}`}>
                   <p className={`text-[11px] font-medium xl:text-sm ${alpha === item ? 'text-[#25A249]' : 'text-[#101828]'}`}>
                      {item}
                   </p>
                </div>
              )
             })}
        </div> */}

          <div className="flex items-center justify-between w-full mt-6 xl:mt-7">
            <p className="text-[12px] font-semibold text-[#53545C] md:text-[13px] xl:text-base">
              {schoolName} Programmes
            </p>

            <div className="flex items-center justify-end">
              <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
                Show
              </p>
              <div className="flex items-center justify-between px-[6px] py-[3px] border-[1px] border-[#DDE1E6] rounded mx-[6px] md:mx-2 xl:mx-3">
                <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
                  15
                </p>
                <SlArrowDown className="text-[7px] ml-[10px] xl:ml-[14px] xl:text-[9px]" />
              </div>
              <p className="text-[10px] font-semibold text-[#53545C] md:text-[11px] xl:text-[13px]">
                entries
              </p>
            </div>
          </div>

          <Link
            to="/brochure-by-institution"
            className="flex items-center justify-start w-full mt-5 text-[#25A249] border-b-[1px] border-[#DDE1E6] pb-3 cursor-pointer md:mt-8 xl:mt-11"
          >
            <CgArrowLeft className="xl:text-2xl" />
            <p className="text-[11px] font-semibold md:text-xs xl:text-base">
              Back to instituitions
            </p>
          </Link>

          <div className="flex flex-col items-start justify-start w-full h-full mb-4 md:mb-5 lg:mt-0 xl:mt-1 xl:mb-6">
            {/*DEFAULT INSTTUITION COURSES*/}
            {!showFilter &&
              courses?.map((item) => (
                <div
                  key={item?.id}
                  className="flex flex-col items-start w-full mt-6 border-b-[1px] border-[#DDE1E6] pb-3 md:flex-row md:items-start md:w-full md:mt-10 lg:items-center  lg:mt-8 xl:pb-4"
                >
                  <p className="text-[11px] font-medium text-[#53545C] w-[90%] md:text-[11px] xl:text-[13px]">
                    {item?.title}
                  </p>

                  <div
                    onClick={() => handleDetails(item)}
                    className="flex items-center justify-between px-5 w-[130px] h-8 mt-3 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3 md:w-[125px] md:px-3 xl:w-[145px] xl:px-[15px] xl:h-9"
                  >
                    <p className="text-[10px] font-medium text-[#ffffff] md:text-[10px] xl:text-[13px]">
                      View Details
                    </p>
                    <AiOutlineEye className="text-white xl:text-lg" />
                  </div>
                </div>
              ))}

            {/*FILTERED OR SEARCHED INSTTUITION COURSES*/}
            {showFilter &&
              filterLetter?.map((item) => (
                <div
                  key={item.id}
                  className="flex flex-col items-start w-full mt-6 border-b-[1px] border-[#DDE1E6] pb-3 md:flex-row md:items-start md:w-full md:mt-10 lg:items-center  lg:mt-8 xl:pb-4"
                >
                  <p className="text-[11px] font-medium text-[#53545C] w-[90%] md:text-[11px] xl:text-[13px]">
                    {item?.title}
                  </p>

                  <div
                    onClick={() => handleDetails(item)}
                    className="flex items-center justify-between px-5 w-[130px] h-8 mt-3 cursor-pointer rounded-md bg-[#25A249] md:mt-0 md:ml-3 md:w-[125px] md:px-3 xl:w-[145px] xl:px-[15px] xl:h-9"
                  >
                    <p className="text-[10px] font-medium text-[#ffffff] md:text-[10px] xl:text-[13px]">
                      View Details
                    </p>
                    <AiOutlineEye className="text-white xl:text-lg" />
                  </div>
                </div>
              ))}

            {/* FILTERED OR SEARCHED COURSES NOT FOUND */}
            {(filterLetter.length === 0 && showFilter) |
            (courses?.length === 0 && !loading) ? (
              <div className="flex items-center justify-center w-full h-72 mt-5 md:h-[350px] lg:h-96 xl:h-[400px]">
                <p className="text-[#25A249] font-medium">
                  No courses found...
                </p>
              </div>
            ) : null}

            {/* LOADING STATE */}
            {loading && (
              <div className="flex items-start justify-center w-full h-72 md:h-[350px] lg:h-96 xl:h-[400px]">
                <ThreeDots color="#25A249" />
              </div>
            )}
          </div>

          {/*PAGINATION*/}
          {
            searchTerm === "" && (
              // <div className='w-full'>
              <Pagination2
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
                //  loading={loading}
              />
            )
            // </div>
          }
        </motion.div>

        {/*MODAL*/}
        {modal && (
          <Modal onClick={() => setModal(false)}>
            <CoursesReqModal setModal={setModal} data={modalData} />
          </Modal>
        )}
      </div>
    </DashboardLayout>
  );
};

export default BrochureCourses;
